var React = require('react');

function CloudUploadAlt (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M537.6 226.6A96.11 96.11 0 0 0 448 96a95.51 95.51 0 0 0-53.3 16.2A160 160 0 0 0 96 192c0 2.7.1 5.4.2 8.1A144 144 0 0 0 144 480h368a128 128 0 0 0 25.6-253.4zM393.4 288H328v112a16 16 0 0 1-16 16h-48a16 16 0 0 1-16-16V288h-65.4a16 16 0 0 1-11.3-27.3l105.4-105.4a16.06 16.06 0 0 1 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M393.4 288H328v112a16 16 0 0 1-16 16h-48a16 16 0 0 1-16-16V288h-65.4a16 16 0 0 1-11.3-27.3l105.4-105.4a16.06 16.06 0 0 1 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z","className":"fa-primary","key":2})]);
}

CloudUploadAlt.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = CloudUploadAlt;

CloudUploadAlt.default = CloudUploadAlt;
